import React, { Component } from 'react';

import { deepDiver } from 'helpers/utilities';
import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';
import {
  StyledHeader,
  StyledMain,
  StyledHeaderContainer,
  StyledAddButton,
  StyledTableContainer,
} from 'helpers/StyledTableComponentsHelper';
import HeaderWithPeriod from 'components/shared/HeaderWithPeriod';

import { AccentColor } from 'helpers/AccentColorHelper';
import { featureEnabled } from 'helpers/ToggleBot';

import { getLandlordTrafficSources } from 'actions/landlordLeadsActions';
import * as bookings from 'actions/bookingsActions';
import * as landlordShowings from 'actions/landlordShowingsActions';

import { getProperties, getUnits, getAgents } from 'actions/landlordPropertiesActions';

import ShowingOverview from './components/ShowingOverview';

import withMobileDialog from '@material-ui/core/withMobileDialog';
import { formatPhone } from 'helpers/Formatter';

import TableFilters from 'components/ui/TableFilters';
import { withStyles } from '@material-ui/core/styles';
import StatusTag from 'components/ui/StatusTag';
import TabbedTable from 'components/ui/TabbedTable';
import MobileTable from 'components/ui/MobileTable';

import Drawer from '@material-ui/core/Drawer';
import { default as AntDrawer } from 'components/ui/Drawer';
import CreateShowingDrawerWizard from './CreateShowingDrawerWizard';

const StyledDrawer = withStyles({
  paperAnchorLeft: { maxWidth: '550px', width: '100% !important' },
  background: '#fbfbfb',
})(Drawer);

const statuses = ['no_show', 'complete', 'cancelled', 'assign', 'upcoming'];

export default withMobileDialog()(
  connect(
    store => ({
      showings: store.landlordShowings.showings,
      showingsCounts: store.landlordShowings.showingsCounts,
      fetchingShowings: store.landlordShowings.fetchingShowings,
      showingDetails: store.landlordShowings.showingDetails,
      properties: store.landlordProperties.properties,
      bookingHistory: store.landlordShowings.bookingHistory,
      unitTypes: deepDiver(store, 'companyDetails.companyPreferences.unit_types') || [],
      trafficSources: deepDiver(store, 'landlordLeads.trafficSources') || [],
      agents: store.landlordProperties.agents,
      allowManualBooking: store.userTypes.allowManualBooking,
    }),
    {
      getProperties,
      getAgents,
      getUnits,
      getLandlordTrafficSources,
      ...bookings,
      ...landlordShowings,
    }
  )(
    class Showings extends Component {
      constructor(props) {
        super(props);
        this.state = {
          createShowingDrawerOpen: false,
          drawerIsOpen: false,
          showAllBookings: false,
          filtersActive: false,
          filters: {
            search: '',
            properties: Array(this.props.properties.length).fill(false),
            statuses: Array(statuses.length).fill(false),
          },
          drawerVisible: false,
          currentTab: 'upcoming',
          offset: 0,
          sortKey: '',
          sortOrder: '',
        };
      }

      setRef = ref => (this.table = ref);

      fetchShowingsAndStats = () => {
        this.props.getShowingStats();
        this.fetchShowings();
      };

      componentDidMount = () => {
        this.fetchShowingsAndStats();
        this.props.getLandlordTrafficSources();
        this.props.getProperties({ for_multiselect: true });
      };

      getAgents = (dayOfWeek) => {
        this.props.getAgents({
          manual_selection_agents_only: true,
          dayOfWeek
        });
      };

      filterProperties = booleanArrayMask => {
        return this.props.properties.filter((_, i) => booleanArrayMask[i]);
      };

      filterStatuses = booleanArrayMask => {
        return statuses.filter((_, i) => booleanArrayMask[i]);
      };

      handleClearSearch = setFieldValue => {
        this.setState(
          {
            filtersActive: false,
            filters: {
              search: '',
              properties: Array(this.props.properties.length).fill(false),
              statuses: Array(statuses.length).fill(false),
            },
            offset: 0,
          },
          () => this.fetchShowings()
        );

        if (this.table) this.table.scrollToTop(0);
        setFieldValue('search', '');
        setFieldValue('properties', Array(this.props.properties.length).fill(false));
        setFieldValue('statuses', Array(statuses.length).fill(false));
      };

      handleFilters = values => {
        const isFiltersUntouched =
          values.search === '' &&
          !values.properties.includes(true) &&
          !values.statuses.includes(true);
        const newState = {
          filtersActive: !isFiltersUntouched,
          filters: {
            search: values.search,
            properties: values.properties,
            statuses: values.statuses,
          },
          drawerVisible: false,
          offset: 0,
        };
        if (this.table) this.table.scrollToTop(0);
        this.setState(newState, () => this.fetchShowings());
      };

      columns = [
        {
          title: 'Status',
          dataKey: 'status',
          sortable: false,
          width: 150,
          render: ({ data }) => <StatusTag status={data || 'upcoming'} />,
        },
        {
          title: 'Full Name',
          dataKey: 'full_name',
          sortable: true,
          width: 300,
        },
        {
          title: 'Showing Date',
          dataKey: 'book_date',
          sortable: true,
          width: 200,
        },
        {
          title: 'Desired Unit',
          dataKey: 'unit_type',
          sortable: true,
          width: 175,
        },
        {
          title: 'Phone Number',
          dataKey: 'phone_number',
          sortable: false,
          width: 150,
          render: ({ data }) => formatPhone(data),
        },
        {
          title: 'Email',
          dataKey: 'email',
          sortable: true,
          width: 200,
        },
        {
          title: 'Scheduled To',
          dataKey: 'assigned_agent',
          sortable: true,
          width: 250,
        },
        {
          title: 'Booked By',
          dataKey: 'booked_by',
          sortable: false,
          width: 250,
        },
        {
          title: 'Calendar Synced',
          dataKey: 'event_id',
          sortable: false,
          width: 200,
          render: ({ data }) => (data ? 'Yes' : 'No'),
        },
      ];

      handleTabChange = (tabName, _queryObj) => {
        this.setState(
          {
            currentTab: tabName,
            offset: 0,
          },
          () => {
            this.fetchShowings();
          }
        );
        if (this.table) this.table.scrollToTop(0);
      };

      handleSort = (key, order) => {
        this.setState(
          {
            sortKey: key,
            sortOrder: order,
            offset: 0,
          },
          () => {
            this.fetchShowings();
          }
        );
        if (this.table) this.table.scrollToTop(0);
      };

      toggleDrawer = async tenantID => {
        await this.props.getProspectDetails(tenantID);
        this.toggleProspectDetailsDialog();
      };

      fetchShowings = () => {
        const { filters, filtersActive, currentTab, offset, sortKey, sortOrder } = this.state;

        let fetchPromise = null;

        let filterOptions = {
          sort_key: sortKey,
          sort_order: sortOrder,
        };

        if (filtersActive) {
          const propertiesToFilter = this.filterProperties(filters.properties).map(
            data => data.value
          );
          const statusesToFilter = this.filterStatuses(filters.statuses);

          filterOptions = {
            query: filters.search,
            property_ids: propertiesToFilter,
            statuses: statusesToFilter,
            sort_key: sortKey,
            sort_order: sortOrder,
          };

          fetchPromise = this.props.getFilteredShowings('all', offset, filterOptions);
        } else {
          fetchPromise = this.props.getFilteredShowings(currentTab, offset, filterOptions);
        }

        fetchPromise.then(() => {
          this.setState({
            offset: this.props.showings.length,
          });
        });
      };

      accentColor = AccentColor();

      toggleDrawer = showingID => {
        if (!this.state.showDrawer && showingID) {
          this.props.getShowing(showingID).then(() => {
            this.setState({
              showDrawer: true,
            });
          });
          return;
        }

        this.setState({
          showDrawer: false,
        });
      };

      openCreateShowingDrawer = () => {
        this.setState({ createShowingDrawerOpen: true });
      };

      closeCreateShowingDrawer = () => {
        this.setState({ createShowingDrawerOpen: false });
      };

      handleCreateShowingSuccess = () => {
        this.getShowingAndShowings();
      };

      markNoShow = async () => {
        await this.props.putShowing(this.props.showingDetails.id, { no_show: true });
        this.getShowingAndShowings();
      };

      cancelShowing = async cancellationReason => {
        await this.props.cancelBookingByAgent(this.props.showingDetails.id, cancellationReason);
        this.getShowingAndShowings();
      };

      getShowingAndShowings = async (getShowing = true) => {
        this.setState(
          {
            offset: 0,
          },
          () => {
            this.fetchShowingsAndStats();
          }
        );

        if (getShowing) {
          this.props.getShowing(this.props.showingDetails.id);
        }
      };

      render() {
        const { filters } = this.state;
        const { showings, showingsCounts } = this.props;

        const filterOptions = [
          {
            useSearch: true,
            options: this.props.properties.map(data => data.label),
            name: 'properties',
            title: 'Select properties to filter by',
          },
          {
            useSearch: false,
            options: statuses,
            name: 'statuses',
            title: 'Filter by showing status',
          },
        ];

        const tabs = [
          {
            title: 'Upcoming',
            label: 'Upcoming',
            value: 'upcoming',
            count: showingsCounts['upcoming'] || 0,
            onClick: () => this.handleTabChange('upcoming', { subset: 'upcoming' }),
          },
          {
            title: 'Pending Assignment',
            label: 'Pending Assignment',
            value: 'assign',
            count: showingsCounts['assign'] || 0,
            onClick: () => this.handleTabChange('assign', { subset: 'assign' }),
          },
          {
            title: 'Complete',
            label: 'Complete',
            value: 'complete',
            count: showingsCounts['complete'] || 0,
            onClick: () => this.handleTabChange('complete', { subset: 'complete' }),
          },
          {
            title: 'No Show',
            label: 'No Show',
            value: 'no_show',
            count: showingsCounts['no_show'] || 0,
            onClick: () => this.handleTabChange('no_show', { subset: 'no_show' }),
          },
          {
            title: 'Cancelled',
            label: 'Cancelled',
            value: 'cancelled',
            count: showingsCounts['cancelled'] || 0,
            onClick: () => this.handleTabChange('cancelled', { subset: 'cancelled' }),
          },
          {
            title: 'All',
            label: 'All',
            value: 'all',
            count: showingsCounts['all'] || 0,
            onClick: () => this.handleTabChange('all', { subset: 'all' }),
          },
        ];

        const filteredData = showings.map(datum => {
          if (datum.phone_number) {
            return {
              ...datum,
              phone_number: formatPhone(datum.phone_number),
            };
          } else {
            return datum;
          }
        });

        return (
          <StyledMain>
            <StyledHeaderContainer>
              <StyledHeader>
                <HeaderWithPeriod headerText={<span>Showings</span>} newStyle />
                <StyledAddButton
                  accentColor={this.accentColor}
                  onClick={this.openCreateShowingDrawer}
                >
                  Add new
                </StyledAddButton>
              </StyledHeader>
              <TableFilters
                filters={filters}
                handleSubmitFilters={this.handleFilters}
                handleClearFilters={this.handleClearSearch}
                filterOptions={filterOptions}
                accentColor={this.accentColor}
              />
            </StyledHeaderContainer>

            <StyledTableContainer>
              {this._renderTableView({ filteredData, tabs })}
              {this._renderMobileView({
                filteredData,
                tabs,
                currentTab: this.state.currentTab,
                tabChange: this.handleTabChange,
              })}
            </StyledTableContainer>
            <AntDrawer
              maskClosable={false}
              keyboard
              visible={this.state.createShowingDrawerOpen}
              onClose={this.closeCreateShowingDrawer}
              closable={false}
              width={600}
            >
              {this.state.createShowingDrawerOpen && (
                <CreateShowingDrawerWizard
                  showForceBooking={this.props.allowManualBooking}
                  getAgents={this.getAgents}
                  agents={this.props.agents}
                  handleClose={this.closeCreateShowingDrawer}
                  properties={this.props.properties}
                  unitTypes={this.props.unitTypes}
                  trafficSources={this.props.trafficSources}
                  onSuccess={this.getShowingAndShowings}
                  getLandlordTrafficSources={this.props.getLandlordTrafficSources}
                />
              )}
            </AntDrawer>
            {this.renderShowingDetails()}
          </StyledMain>
        );
      }

      renderShowingDetails = () => (
        <StyledDrawer open={this.state.showDrawer} onClose={this.toggleDrawer} anchor="left">
          <ShowingOverview
            toggleDrawer={this.toggleDrawer}
            showingDetails={this.props.showingDetails}
            markNoShow={this.markNoShow}
            cancelShowing={this.cancelShowing}
            getShowingAndShowings={this.getShowingAndShowings}
            getHistory={this.props.getHistory}
            bookingHistory={this.props.bookingHistory}
          />
        </StyledDrawer>
      );

      _renderTableView = ({ filteredData, tabs }) => {
        let groupBy = 'property_name';
        if (featureEnabled('ui.properties.namespace_by_city')) {
          groupBy = 'property_name_city';
        }
        return (
          <MediaQuery query="(min-device-width: 750px)">
            <TabbedTable
              setRef={this.setRef}
              groupRowsBy={groupBy}
              tabs={tabs}
              columns={this.columns}
              data={filteredData}
              loadMoreData={this.fetchShowings}
              isLoading={this.props.fetchingShowings}
              filtersActive={this.state.filtersActive}
              onRowClick={data => {
                this.toggleDrawer(data.original_id);
              }}
              onColumnClick={data => {
                this.handleSort(data.key, data.order);
              }}
            />
          </MediaQuery>
        );
      };

      _renderMobileView = ({ filteredData, tabs, currentTab, tabChange }) => {
        let groupBy = 'property_name';
        if (featureEnabled('ui.properties.namespace_by_city')) {
          groupBy = 'property_name_city';
        }
        return (
          <MediaQuery query="(max-device-width: 750px)">
            <MobileTable
              groupRowsBy={groupBy}
              data={filteredData}
              tabs={tabs}
              tabIndex={currentTab}
              tabChange={tabChange}
              filtersActive={this.state.filtersActive}
              columns={this.columns}
              title="full_name"
              tag="status"
              stickyHeaderTop={this.state.filters.search ? '137px' : '107px'}
              fieldsAboveFold={[
                {
                  title: 'Book Date',
                  key: 'book_date',
                },
                {
                  title: 'Scheduled To',
                  key: 'assigned_agent',
                },
              ]}
              fieldsBelowFold={[
                {
                  title: 'Phone Number',
                  key: 'phone_number',
                },
                {
                  title: 'Email',
                  key: 'email',
                },
                {
                  title: 'Booked by',
                  key: 'booked_by',
                },
                {
                  title: 'Desired unit',
                  key: 'unit_type',
                },
              ]}
              onRowClick={data => {
                this.toggleDrawer(data.id);
              }}
            />
          </MediaQuery>
        );
      };
    }
  )
);
